module.exports = __webpack_public_path__ + "static/praveen-730cc1f82a7da966f8fd4bf7ec6c4447.png";